module.exports = __webpack_public_path__ + "assets/img/flex.a59235aa.png";